import React, { useState } from "react";
import {
  Container,
  Grid,
  Typography,
  AppBar,
  Toolbar,
  CssBaseline,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
} from "@mui/material";
import { IconButton } from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useAuth } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import "../../App.css";

const products = [
  {
    name: "GayaT",
    links: [
      { label: "Platform Link", url: "https://ip.trackcoredata.com" },
      {label : "Smart Gaushala", url: "https://verdict-smart-gaushala.trackcoredata.com/"}
    ],
    link2:
      "https://coredata.co.in/break-throughs/solutions/indoor-positioning",
    description:
      "Indoor positioning tracks assets or people in real time within enclosed spaces, delivering precise locations, geofence alerts, and efficiency insights.",
    image: "/gayat_platform.png",
  },
  {
    name: "Survitan",
    links: [
      { label: "Platform Link", url: "https://medical-iot.trackcoredata.com" },
    ],
    link2:
      "https://coredata.co.in/break-throughs/solutions/patient-monitoring",
    description:
      "Smart Room Monitoring tracks presence and conditions with radar, sensors, fall detection, and voice alerts—improving safety, automation, and decisions.",
    image: "/survitan_platform.png",
  },
  {
    name: "Solvista",
    links: [
      { label: "Platform Link", url: "https://helios.trackcoredata.com" },
    ],
    link2:
      "https://coredata.co.in/break-throughs/solutions/solar-street-light-monitoring-system",
    description:
      "Solar Street Light Monitoring enables remote tracking of streetlights, checking energy, battery health, and light status in real time for efficient, reliable upkeep.",
    image: "/solvista_platform.png",
  },
  {
    name: "JalSense",
    links: [
      { label: "Platform Link", url: "https://aquadata.trackcoredata.com" },
      { label : "Satnavari (Nagpur) ", url: "https://satnavari.trackingcoredata.com" }
    ],
    link2:
      "https://coredata.co.in/break-throughs/solutions/water-supply-monitoring-system",
    description:
      "The Water Supply Monitoring System uses IoT to track motors, flow, quality, and overflows, providing smart alerts and dashboards for efficiency.",
    image: "/jalsense_platform.png",
  },
  {
    name: "LinkIn",
    links: [{ label: "Platform Link", url: "https://prss.trackcoredata.com" }],
    link2:
      "https://coredata.co.in/break-throughs/solutions/public-response-support-system",
    description:
      "The Public Response Support System lets citizens report issues, give feedback, or seek help securely, enabling two-way communication with camera links.",
    image: "/linkin_platfrom.png",
  },
  {
    name: "AgriPulse",
    links: [{ label: "Platform Link", url: "https://agrim.trackcoredata.com" }],
    link2:
      "http://coredata.co.in/break-throughs/solutions/soil-health-monitoring-system",
    description:
      "The Soil Health Monitoring System gives farmers real-time soil insights and AI-based fertilizer advice, with IoT sensors, expert support, and AgriPulse access.",
    image: "/agripulse_platform.png",
  },
];

const ProductDashboard = () => {
  const [isHovered, setIsHovered] = useState({});
  const [openModalIndex, setOpenModalIndex] = useState(null);

  const { logout } = useAuth();
  const history = useHistory();

  const handleLogout = async () => {
    try {
      await logout();
      document.cookie =
        "customToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.trackcoredata.com;";
      history.push("/");
    } catch {
      console.log("Failed to logout");
    }
  };

  const handleOpenModal = (index) => {
    setOpenModalIndex(index);
  };

  const handleCloseModal = () => {
    setOpenModalIndex(null);
  };

  return (
    <>
      <CssBaseline />
      <AppBar
        position="static"
        sx={{
          background: "#FFF",
          boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.08)",
          zIndex: 1100,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img
            src="/logocd.png"
            alt="My Logo"
            style={{ height: "30px", cursor: "pointer" }}
            onClick={() => (window.location.href = "/")}
          />

          <Typography
            sx={{
              textAlign: "center",
              color: "#1A1A1A",
              display: { xs: "none", sm: "block" },
              fontSize: { xs: "1rem", sm: "1.3rem", md: "1.5rem" },
              fontWeight: 600,
            }}
          >
            Product Dashboard
          </Typography>

          <IconButton edge="end" color="inherit" onClick={handleLogout}>
            <ExitToAppIcon style={{ color: "#50c1e9", height: 45, width: 35 }} />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container>
        <Grid container spacing={3} style={{ marginTop: "3rem" }}>
          {products.map((product, index) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
              <Grid
                container
                style={{
                  borderRadius: "0.25rem",
                  border: isHovered[index]
                    ? "1.5px solid #1916D3"
                    : "1.5px solid #CCCCCC",
                  background: "#FFF",
                  boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.04)",
                  padding: "1rem",
                }}
                onMouseEnter={() =>
                  setIsHovered((prev) => ({ ...prev, [index]: true }))
                }
                onMouseLeave={() =>
                  setIsHovered((prev) => ({ ...prev, [index]: false }))
                }
              >
                {/* Image */}
                <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={product.image}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "0.25rem",
                      objectFit: "contain",
                    }}
                    alt={product.name}
                  />
                </Grid>

                {/* Name */}
                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                  <Typography
                    style={{
                      color: "rgba(0, 0, 0, 0.90)",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "1.5rem",
                      fontWeight: 600,
                    }}
                  >
                    {product.name}
                  </Typography>
                </Grid>

                {/* Description */}
                <Grid item xs={11} style={{ marginTop: "0.5rem" }}>
                  <Typography
                    style={{
                      color: "#1A1A1A",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 400,
                    }}
                  >
                    {product.description}
                  </Typography>
                </Grid>

                {/* Buttons */}
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: "2.12rem",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {/* More Info */}
                  <div
                    onClick={() => window.open(product.link2, "_blank")}
                    style={{
                      display: "flex",
                      width: "6rem",
                      height: "2.2rem",
                      padding: "0.625rem 0.7rem",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "0.75rem",
                      background: "#FFF",
                      boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.12)",
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      style={{
                        color: "#000",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                      }}
                    >
                      More Info...
                    </Typography>
                  </div>

                  {/* Open Modal */}
                  <div
                    onClick={() => handleOpenModal(index)}
                    style={{
                      display: "flex",
                      width: "6rem",
                      height: "2.2rem",
                      padding: "0.625rem 1.5rem",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "0.75rem",
                      background: "#0E2748",
                      boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.12)",
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      style={{
                        color: "#FFF",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                      }}
                    >
                      Open &gt;
                    </Typography>
                  </div>
                </Grid>
              </Grid>

              {/* Modal for this product */}
              <Dialog
                open={openModalIndex === index}
                onClose={handleCloseModal}
              >
                <DialogTitle>{product.name} - Available Platforms</DialogTitle>
                <DialogContent>
                  <Stack spacing={2} sx={{ mt: 1 }}>
                    {product.links.map((linkItem, i) => (
                      <Button
                        key={i}
                        variant="outlined"
                        href={linkItem.url}
                        target="_blank"
                        fullWidth
                        sx={{ borderRadius: "12px", textTransform: "none" }}
                      >
                        {linkItem.label}
                      </Button>
                    ))}
                  </Stack>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseModal} color="error">
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          textAlign: "center",
          padding: "1rem",
          marginTop: "2rem",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          backgroundColor: "transparent",
          color: "black",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "0.8rem", sm: "1rem", md: "1.2rem" },
            fontFamily: "serif",
          }}
        >
          © CoreData Networks {new Date().getFullYear()} | All Rights Reserved.
        </Typography>
      </Box>
    </>
  );
};

export default ProductDashboard;
